
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/login",
      function () {
        return require("private-next-pages/elearning/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/login"])
      });
    }
  